/**
 * 获取起始结束点位置
 * anchor和focus不一定谁在谁之前...
 * @param {*} anchor
 * @param {*} focus
 */
export function getStartEndPoint(anchor, focus) {
    let first = anchor;
    let end = focus;

    if (
        anchor.path[0] > focus.path[0]
        || (anchor.path[0] === focus.path[0] && anchor.offset > focus.offset)
    ) {
        first = focus;
        end = anchor;
    }

    return {
        first,
        end,
        sIndex: first.path[0],
        eIndex: end.path[0],
        sOffset: first.offset,
        eOffset: end.offset,
    };
}
